import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Subscription } from 'rxjs';
import { AppStateService } from '../app-state.service';
import { VSKDokument } from '../model/vsk-dokument';
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'app-hlavicka-dokumentu',
    templateUrl: './hlavicka-dokumentu.component.html',
    styleUrls: ['./hlavicka-dokumentu.component.css'],
    standalone: false
})
export class HlavickaDokumentuComponent implements OnInit {

  @Input() jazyk: string = "SK";
  @Output() jazykZmena = new EventEmitter<string>();

  data: VSKDokument;

  @Input() disabled = false;

  jazykyFormulara: string[] = [];
  jazykyFormularaString: string = '';

  dataSubscription: Subscription;

  readonly DOKUMENT_STUD_PROGRAM = 1;
  readonly DOKUMENT_OSOBA = 2;
  readonly DOKUMENT_PODPROGRAM = 3;
  readonly DOKUMENT_HABILITACNE_A_INAUGURACNE_KONANIE = 4;

  idDruhDokumentu = 0;

  constructor(private appStateService: AppStateService,
    private translateService: TranslateService) { }

  ngOnInit(): void {

    this.dataSubscription = this.appStateService.dataFetched
      .subscribe((data: VSKDokument) => {

      this.data = data;
      this.jazykyFormulara = this.data.jazykyFormulara;
      this.jazykyFormularaString =
        this.jazykyFormulara.map(x => x).join(", ");

    });

    this.idDruhDokumentu = this.appStateService.idDruhDokumentu;

  }

  onJazykChange() {
    // console.log('jazyk change');
    this.jazykZmena.emit(this.jazyk);
  }

  getRadioTooltip(kodJazyk: string) {
    return this.translateService.instant('Formulár v') + ' ' + kodJazyk + ' ' + this.translateService.instant('jazyku');
  }

  getJazykyFormularaString(): string {
    return this.jazykyFormulara.map(x => x).join(", ");
  }

  getStudiumPrePodprogramPopis(): string {
    let result = '';

    if (this.data.podprogramStupenStudiaKod || this.data.podprogramStupenStudiaPopis) {
      result += this.translateService.instant('Stupeň') + ' - ';
      result += this.data.podprogramStupenStudiaKod;
      result += ' - ' +  this.data.podprogramStupenStudiaPopis;
    }
    if (this.data.podprogramFormaStudia) {
      if (this.data.podprogramStupenStudiaKod || this.data.podprogramStupenStudiaPopis) {
        result += ', ';
      }
      result += this.translateService.instant('forma') + ' - ' + this.data.podprogramFormaStudia;
    }
    if (this.data.podprogramTypStudia) {
      if (this.data.podprogramStupenStudiaKod || this.data.podprogramStupenStudiaPopis || this.data.podprogramFormaStudia) {
        result += ', ';
      }
      result += this.translateService.instant('typ') + ' - ' + this.data.podprogramTypStudia;
    }

    return result;
  }



  ngOnDestroy() {
    this.dataSubscription.unsubscribe();
  }


}
